"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ProsemirrorTables = require("prosemirror-tables");
var browser_1 = require("@syl-editor/core-utilities/dist/lib/libs/browser");
var addColumnAfter = ProsemirrorTables.addColumnAfter, addColumnBefore = ProsemirrorTables.addColumnBefore, addRowAfter = ProsemirrorTables.addRowAfter, addRowBefore = ProsemirrorTables.addRowBefore, deleteColumn = ProsemirrorTables.deleteColumn, deleteRow = ProsemirrorTables.deleteRow, deleteTable = ProsemirrorTables.deleteTable, mergeCells = ProsemirrorTables.mergeCells, splitCell = ProsemirrorTables.splitCell;
var defaultMenuLocale = {
    cut: '剪切',
    copy: '复制',
    paste: '粘贴',
    mergeCells: '合并单元格',
    splitCell: '拆分单元格',
    addColumnBefore: '左边插入列',
    addColumnAfter: '右边插入列',
    addRowBefore: '上边插入行',
    addRowAfter: '下边插入行',
    deleteRow: '删除当前行',
    deleteColumn: '删除当前列',
    deleteTable: '删除表格'
};
var NODE_NAME = {
    TABLE: 'table',
    TABLE_CELL: 'table_cell',
    TABLE_HEADER: 'table_header',
    TABLE_ROW: 'table_row'
};
exports.NODE_NAME = NODE_NAME;
var createMenu = function (localeConfig) {
    var locale = Object.assign({}, defaultMenuLocale, localeConfig);
    return [
        {
            name: locale.cut,
            key: 'cut',
            callback: function (editorView) {
                var state = editorView.state;
                editorView.focus();
                var sel = state.selection;
                if (sel.empty)
                    return;
                document.execCommand('cut');
            }
        },
        {
            name: locale.copy,
            key: 'copy',
            callback: function (editorView) {
                editorView.focus();
                document.execCommand('copy');
            }
        },
        {
            name: locale.paste,
            key: 'paste',
            disable: true,
            tip: "\u8BF7\u4F7F\u7528 <b>" + (browser_1.browser.mac ? '⌘+V' : 'Ctrl+V') + "</b> \u7C98\u8D34",
            callback: function (editorView) { }
        },
        '|',
        {
            name: locale.mergeCells,
            key: 'mergeCells',
            callback: function (editorView) {
                var state = editorView.state, dispatch = editorView.dispatch;
                mergeCells(state, dispatch);
            }
        },
        {
            name: locale.splitCell,
            key: 'splitCell',
            callback: function (editorView) {
                var state = editorView.state, dispatch = editorView.dispatch;
                splitCell(state, dispatch);
            }
        },
        '|',
        {
            name: locale.addColumnBefore,
            key: 'addColumnBefore',
            callback: function (editorView) {
                var state = editorView.state, dispatch = editorView.dispatch;
                addColumnBefore(state, dispatch);
            }
        },
        {
            name: locale.addColumnAfter,
            key: 'addColumnAfter',
            callback: function (editorView) {
                var state = editorView.state, dispatch = editorView.dispatch;
                addColumnAfter(state, dispatch);
            }
        },
        {
            name: locale.addRowBefore,
            key: 'addRowBefore',
            callback: function (editorView) {
                var state = editorView.state, dispatch = editorView.dispatch;
                addRowBefore(state, dispatch);
            }
        },
        {
            name: locale.addRowAfter,
            key: 'addRowAfter',
            callback: function (editorView) {
                var state = editorView.state, dispatch = editorView.dispatch;
                addRowAfter(state, dispatch);
            }
        },
        '|',
        {
            name: locale.deleteRow,
            key: 'deleteRow',
            callback: function (editorView) {
                var state = editorView.state, dispatch = editorView.dispatch;
                deleteRow(state, dispatch);
            }
        },
        {
            name: locale.deleteColumn,
            key: 'deleteColumn',
            callback: function (editorView) {
                var state = editorView.state, dispatch = editorView.dispatch;
                deleteColumn(state, dispatch);
            }
        },
        {
            name: locale.deleteTable,
            key: 'deleteTable',
            callback: function (editorView) {
                var state = editorView.state, dispatch = editorView.dispatch;
                deleteTable(state, dispatch);
            }
        }
    ];
};
exports.createMenu = createMenu;
var TABLE_CONFIG = {
    allowTableNodeSelection: false,
    defaultCellWidth: 88,
    cellAttributes: {},
    useTableHeader: true
};
exports.TABLE_CONFIG = TABLE_CONFIG;
//# sourceMappingURL=const.js.map